const toRem = (pixel: number): string => `${pixel / 16}rem`;

export default toRem;
